module.exports = __webpack_public_path__ + "media/images/font/Gustavo-ThinItalic-b765db127290be448d164b63bbeccdbc.svg";